import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Provider } from 'react-redux'
import { store } from './store/store'
import Signin from '././(auth)/signin.jsx'
import Signup from '././(auth)/Signup.jsx'
import AcceptInvitation from '././(auth)/AcceptInvitation.jsx'
import Dashboard from '././(app)/Dashboard'
import AnalyticsOverview from '././(app)/AnalyticsOverview'
import WebAnalytics from '././(app)/WebAnalytics'
import EmbeddingGuide from '././(app)/EmbeddingGuide'
import AIConfiguration from '././(app)/AIConfiguration'
import TeamManagement from '././(app)/TeamManagement'
import AITrainingData from '././(app)/AITrainingData'
import BugReports from '././(app)/BugReports'
import VisualGuideManager from '././(app)/VisualGuideManager'
import VisualFlowDetails from '././(app)/VisualFlowDetails'
import IntentManagement from '././(app)/IntentManagement'
import ChatLogs from '././(app)/ChatLogs'
import MediaLibrary from '././(app)/MediaLibrary'
import SubscriptionBilling from '././(app)/SubscriptionBilling'
import ProjectBuilder from '././(app)/ProjectBuilder'
import Profile from '././(app)/Profile'
import Settings from '././(app)/Settings'
import ProtectedRoute from './components/(admin)/ProtectedRoute'
import { DashboardSocketProvider } from './context/DashboardSocketContext'
import './App.css'

function App() {
  console.log('App component is rendering')
  
  return (
    <Provider store={store}>
      <Router>
        <DashboardSocketProvider>
        <div className="App">
          <Routes>
            <Route path="/signin" element={<Signin />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/accept-invitation" element={<AcceptInvitation />} />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/analytics" 
              element={
                <ProtectedRoute>
                  <AnalyticsOverview />
                </ProtectedRoute>
              } 
            />
            <Route
              path="/web-analytics"
              element={
                <ProtectedRoute>
                  <WebAnalytics />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/project-builder" 
              element={
                <ProtectedRoute>
                  <ProjectBuilder />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/embedding-guide" 
              element={
                <ProtectedRoute>
                  <EmbeddingGuide />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/ai-configuration" 
              element={
                <ProtectedRoute>
                  <AIConfiguration />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/teammanagement" 
              element={
                <ProtectedRoute>
                  <TeamManagement />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/ai-training" 
              element={
                <ProtectedRoute>
                  <AITrainingData />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/bug-reports" 
              element={
                <ProtectedRoute>
                  <BugReports />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/visual-guides" 
              element={
                <ProtectedRoute>
                  <VisualGuideManager />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/visual-guides/:intentKey" 
              element={
                <ProtectedRoute>
                  <VisualFlowDetails />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/intent-management" 
              element={
                <ProtectedRoute>
                  <IntentManagement />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/chat-logs" 
              element={
                <ProtectedRoute>
                  <ChatLogs />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/media-library" 
              element={
                <ProtectedRoute>
                  <MediaLibrary />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/billing" 
              element={
                <ProtectedRoute>
                  <SubscriptionBilling />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/profile" 
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<Navigate to="/signin" replace />} />
          </Routes>
        </div>
        </DashboardSocketProvider>
      </Router>
    </Provider>
  )
}

export default App